import { CurrentUser } from "../../model/CurrentUser";

const IF = require( "infrontjs" );

import { LoginState } from "../auth/LoginState";

export class LogoutState extends IF.State
{
    static ROUTE = '/logout';
    static ID = 'logout';

    canEnter()
    {
        return true;
    }

    async enter()
    {
        this.app.currentUser = null;
        this.app.api.delete( '/auth/session' );
        this.app.storage.deleteSessionToken();
        this.app.api.deleteSessionToken();
        this.app.router.redirect( LoginState.ROUTE );
    }

    async exit()
    {
    }
};
